(function () {
  var THRESHOLD = parseInt(window.free_shipping_price) || 0;
  var TXT = window.free_shipping_text || {};

  if (!THRESHOLD) return;

  function formatPrice(cents) {
    try {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.money_format || '฿{{amount_no_decimals}}');
      }
    } catch (e) {}
    // Fallback: plain number
    return '฿' + Math.round(cents / 100);
  }

  var PROGRESS_CLASSES = ['progress-30', 'progress-60', 'progress-100', 'progress-free'];

  function setProgressClass(el, cls) {
    if (!el) return;
    PROGRESS_CLASSES.forEach(function (c) { el.classList.remove(c); });
    if (cls) el.classList.add(cls);
  }

  function updateBar(wrapper) {
    var progressBar   = wrapper.querySelector('[data-shipping-progress]');
    var progressMeter = wrapper.querySelector('[data-free-shipping-progress-meter]');
    var messageEl     = wrapper.querySelector('.message');

    if (!progressBar || !progressMeter || !messageEl) {
      console.warn('[FreeShipping] missing elements', { progressBar: progressBar, progressMeter: progressMeter, messageEl: messageEl });
      return;
    }

    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var totalCents = parseInt(cart.total_price) || 0;
        var total      = totalCents / 100;
        var pct        = Math.min((total / THRESHOLD) * 100, 100);

        // Progress bar
        progressBar.classList.toggle('progress-hidden', total === 0);
        progressMeter.style.width = pct + '%';

        var textEnabled = progressBar.dataset.textEnabled === 'true';
        if (textEnabled) {
          var span = progressMeter.querySelector('.text');
          if (span) span.textContent = Math.round(pct) + '%';
        }

        // Progress colour class
        var cls = pct <= 0 ? '' : pct <= 30 ? 'progress-30' : pct <= 60 ? 'progress-60' : pct < 100 ? 'progress-100' : 'progress-free';
        setProgressClass(progressBar, cls);
        setProgressClass(messageEl, cls);

        // Message text
        var msg;
        if (total === 0) {
          msg = (TXT.free_shipping_message || 'Free shipping on orders over') + ' ' + formatPrice(THRESHOLD * 100);
        } else if (pct >= 100) {
          msg = TXT.free_shipping_message_1 || 'You qualify for free shipping!';
        } else {
          var remainingCents = Math.round((THRESHOLD - total) * 100);
          msg = (TXT.free_shipping_message_2 || 'Add') + ' <strong>' +
                formatPrice(remainingCents) + '</strong> ' +
                (TXT.free_shipping_message_3 || 'more to get') + ' ' +
                (TXT.free_shipping_message_4 || 'free shipping');
        }

        messageEl.style.display = 'block';
        messageEl.innerHTML = msg;
      })
      .catch(function (e) { console.error('[FreeShipping] error:', e); });
  }

  function initAll() {
    document.querySelectorAll('[data-free-shipping-wrapper]').forEach(updateBar);
  }

  // Run immediately (script is defer — DOM already parsed, globals already set)
  initAll();

  // Re-run on cart change events dispatched by theme.js
  document.addEventListener('change', function (e) {
    var wrapper = e.target && e.target.closest ? e.target.closest('[data-free-shipping-wrapper]') : null;
    if (wrapper) updateBar(wrapper);
  });

  document.addEventListener('cart-update', initAll);
  document.addEventListener('cart:updated', initAll);

  window.FreeShipping = { update: initAll };

  if (!customElements.get('free-shipping-component')) {
    customElements.define('free-shipping-component', class extends HTMLElement {
      connectedCallback() { updateBar(this); }
    });
  }
}());
